import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { I18n } from '@fiverr-private/i18n-react';
import { raiseToast } from '@fiverr-private/toast';

const raiseErrorToast = () => {
    const { locale } = getContext();

    raiseToast({
        message: <I18n k="machine_translation.something_went_wrong" params={{ locale }} />,
        type: 'error',
    });
};

export default raiseErrorToast;
